@if (client && opportunity) {
  <div class="opp-topbar">
    <div class="opp-topbar-row">
      <div class="opp-topbar-row-content" data-test-id="opportunity-results-topbar">
        <mat-icon class="back-arrow" [routerLink]="['/admin', 'clients', client.clientId]">
          keyboard_backspace
        </mat-icon>
        <span class="route-text" data-test-id="opportunity-results-topbar-client-name">{{ client.clientName }}</span>
        <mat-icon class="chevron">chevron_right</mat-icon>
        <span class="route-text" data-test-id="opportunity-results-topbar-opportunity-name">
          {{ opportunity | opportunityName }}</span
        >
        <mat-icon class="chevron">chevron_right</mat-icon>
        <div class="thin-button" [class.filtered]="overriddenSelectedSearches" (click)="showSearchesSelect()">
          <span>Select searches</span>
        </div>
        @if (isLoading) {
          <mat-icon class="loading"> autorenew </mat-icon>
        }
        @if (!isLoading) {
          <div class="action-buttons" data-test-id="opportunity-results-topbar-expert-count">
            Total: {{ experts.length }}
          </div>
          <span> / </span>
          <div class="action-buttons" data-test-id="opportunity-results-topbar-expert-total-count">
            {{ expertsTotal }}
          </div>
        }
      </div>
      <app-opportunity-actions-menu class="opp-topbar-row-content" [experts]="experts" [opportunity]="opportunity">
      </app-opportunity-actions-menu>
    </div>
    <app-opportunity-top-bar
      data-test-id="opportunity-results-opportunity-top-bar"
      [activePhase]="selectedPhase"
      [selectedSearches]="selectedSearches"
      (selectedPhase)="selectPhase($event)"
    >
    </app-opportunity-top-bar>
    <div class="opp-topbar-row">
      <div class="opp-topbar-row-content flex flex-row gap-[15px]">
        <span class="master-check-box" (click)="selectAllExperts()">
          @if (!selectAllToggle) {
            <mat-icon>check_box_outline_blank</mat-icon>
          }
          @if (selectAllToggle) {
            <mat-icon class="checked">check_box</mat-icon>
          }
          All
        </span>
        <div class="ct-count">
          <mat-icon class="ct-count__icon">person</mat-icon>
          <span class="ct-count__value" data-test-id="opportuntity-results-count-value">{{
            filteredExperts.length
          }}</span>
        </div>
        <div class="search-input">
          <mat-icon class="search-input-icon">search</mat-icon>
          <input
            class="search-input-input"
            type="text"
            placeholder="Search experts..."
            data-test-id="opportunity-results-search-experts"
            [(ngModel)]="searchTerm"
            (keyup)="applyFilter()"
          />
        </div>
        <div
          class="no-emails-toggle"
          title="Filter emails"
          data-test-id="opportunity-results-hide-no-email"
          (click)="applyFilterEmails()"
        >
          @if (!filterEmails) {
            <mat-icon>check_box_outline_blank</mat-icon>
          }
          @if (filterEmails) {
            <mat-icon class="checked">check_box</mat-icon>
          }
          <p>Hide without valid emails</p>
        </div>
        @if (hasAutomatedExperts) {
          <div class="no-emails-toggle" title="Filter Auto" (click)="applyFilterAutoExperts()">
            @if (!filterAutoExperts) {
              <mat-icon>check_box_outline_blank</mat-icon>
            }
            @if (filterAutoExperts) {
              <mat-icon class="checked">check_box</mat-icon>
            }
            <p>Hide automated</p>
          </div>
        }
        @if (segmentOptions.length) {
          <div
            class="thin-button"
            title="Filter segments"
            data-test-id="opportunity-results-segment-filter"
            [class.filtered]="selectedSegmentIds.length"
            [matMenuTriggerFor]="segmentMenu"
          >
            <span class="whitespace-nowrap">
              Segments{{ selectedSegmentIds.length ? ` (${selectedSegmentIds.length})` : '' }}
            </span>
          </div>
          <mat-menu #segmentMenu="matMenu">
            @for (segment of segmentOptions; track segment.id) {
              <button
                mat-menu-item
                class="segment-menu-item"
                data-test-id="opportunity-results-segment-filter-option"
                (click)="toggleSegmentFilter(segment.id); $event.stopPropagation()"
              >
                @if (selectedSegmentIds.includes(segment.id)) {
                  <mat-icon class="checked">check_box</mat-icon>
                } @else {
                  <mat-icon>check_box_outline_blank</mat-icon>
                }
                <span>{{ segment.label }} ({{ segment.count }})</span>
              </button>
            }
          </mat-menu>
        }
      </div>
      <div class="opp-topbar-row-content">
        <!-- Bulk reject/unreject button div -->
        @if (
          selectedPhase === 'identified' ||
          selectedPhase === 'firstFollowUp' ||
          selectedPhase === 'secondFollowUp' ||
          selectedPhase === 'outreachComplete'
        ) {
          <button
            class="thin-button"
            title="Reject experts"
            data-test-id="opportunity-results-reject"
            [disabled]="!selectedExpertsCount"
            (click)="rejectExperts()"
          >
            <mat-icon class="thin-button-icon">thumb_down</mat-icon>
            <span class="selected-span" data-test-id="opportunity-results-reject-label">
              {{ selectedExpertsCount }}
            </span>
          </button>
        }
        @if (selectedPhase === 'rejected') {
          <button
            class="thin-button"
            title="Unreject experts"
            data-test-id="opportunity-results-unreject"
            [disabled]="!selectedExpertsCount"
            (click)="unrejectExperts()"
          >
            <mat-icon class="thin-button-icon">thumb_up</mat-icon>
            <span class="selected-span" data-test-id="opportunity-results-unreject-label">
              {{ selectedExpertsCount }}
            </span>
          </button>
        }
        <!-- Backward button div -->
        @if (selectedPhase !== 'identified' && selectedPhase !== 'outreach') {
          <button
            title="Move back"
            class="thin-button"
            data-test-id="opportunity-results-move-experts-backward"
            [disabled]="isBackButtonDisabled()"
            (click)="handlePhaseMenuSelect('previous')"
            (contextmenu)="backwardRightClick($event); $event.preventDefault()"
          >
            <mat-icon style="transform: scale(0.85)" class="thin-button-icon">west</mat-icon>
            <span class="selected-span" data-test-id="opportunity-results-move-experts-backward-label">
              {{ selectedExpertsCount }}
            </span>
          </button>
        }
        <!-- Forward button div -->
        <!-- && selectedPhase !== 'secondFollowUp' -->
        @if (selectedPhase !== 'completed' && selectedPhase !== 'outreachComplete' && selectedPhase) {
          <button
            class="thin-button"
            title="Move forward"
            data-test-id="opportunity-results-move-experts-forward"
            [disabled]="!selectedExpertsCount"
            (click)="handlePhaseMenuSelect('next')"
            (contextmenu)="forwardRightClick($event); $event.preventDefault()"
          >
            <mat-icon style="transform: scale(0.85)" class="thin-button-icon">east</mat-icon>
            <span class="selected-span" data-test-id="opportunity-results-move-experts-forward-label">
              {{ selectedExpertsCount }}
            </span>
          </button>
        }
        <!-- Responded Experts div in 'identified', 'firstFollowUp', 'secondFollowUp' stages with how_to_reg icon-->
        @if (
          selectedPhase === 'identified' || selectedPhase === 'firstFollowUp' || selectedPhase === 'secondFollowUp'
        ) {
          <button
            class="thin-button"
            title="Responded experts"
            data-test-id="opportunity-move-expert-to-responded"
            [disabled]="!selectedExpertsCount"
            (click)="openRespondedDialog('outreach')"
          >
            <mat-icon style="transform: scale(0.84)" class="thin-button-icon">how_to_reg</mat-icon>
            <span class="selected-span" data-test-id="opportunity-move-expert-to-responded-label">
              {{ selectedExpertsCount }}
            </span>
          </button>
        }
        <!-- Responded Experts div in 'outreachComplete' stage with forward arrow icon-->
        @if (selectedPhase === 'outreachComplete') {
          <button
            class="thin-button"
            title="Responded experts"
            data-test-id="opportunity-results-move-experts-forward"
            [disabled]="!selectedExpertsCount"
            (click)="selectedExpertsCount ? openRespondedDialog('outreach') : ''"
            (contextmenu)="forwardRightClick($event); $event.preventDefault()"
          >
            <mat-icon style="transform: scale(0.85)" class="thin-button-icon">east</mat-icon>
            <span class="selected-span" data-test-id="opportunity-results-move-experts-forward-label">
              {{ selectedExpertsCount }}
            </span>
          </button>
        }
        <button
          class="thin-button"
          title="Send email"
          data-test-id="opportunity-results-email"
          [disabled]="!selectedExpertsCount || selectedPhase === 'rejected'"
          (click)="openEmailDialog()"
        >
          <mat-icon style="transform: scale(0.72)" class="thin-button-icon">mail_outline</mat-icon>
          <span class="selected-span" data-test-id="opportunity-results-email-label">
            {{ selectedExpertsCount }}
          </span>
        </button>
        <button
          class="thin-button"
          title="Download Clerk Chat list"
          data-test-id="opportunity-results-clerk-chat"
          [disabled]="!selectedExpertsCount || selectedPhase === 'rejected'"
          (click)="downloadClerkChatList()"
        >
          <mat-icon style="transform: scale(0.72)" class="thin-button-icon">download</mat-icon>
          <span class="selected-span" data-test-id="opportunity-results-clerk-chat-label">
            {{ selectedExpertsCount }}
          </span>
        </button>
      </div>
    </div>
  </div>
}
<div class="clear"></div>

@if (!isLoading) {
  <app-opportunity-expert-list
    [experts]="filteredExperts"
    [phase]="selectedPhase"
    [client]="client"
    [opportunity]="opportunity"
    [openFilter]="openFilter"
    [showAffiliations]="showAffiliationsToggle"
    (toggleAdminRejectStatusSignal)="toggleAdminRejectedExpertStatus($event)"
    (selectExpertSignal)="selectExpert($event)"
    (navigateToExpertSignal)="navigateToExpert($event)"
    (addExpertiseToSearchSignal)="addExpertiseToSearch($event)"
    (showScreenerResultsSignal)="showExpertScreenerResult($event)"
  >
  </app-opportunity-expert-list>
} @else {
  <div class="flex flex-1 justify-center content-center items-center flex-col h-96">
    <mat-spinner></mat-spinner>
  </div>
}

@if (!isLoading && !filteredExperts.length) {
  <div class="no-experts-message">
    <h2>No experts</h2>
    <i class="material-icons people-icon">people</i>
  </div>
}

<ng-template #isLoadingTmpl>
  <div class="flex flex-1 justify-center content-center items-center flex-col h-96">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<ng-template #phaseMenu let-clickDirection="action">
  <section class="phase-menu" data-test-id="opportunity-phase-menu">
    @for (phase of eligiblePhaseMenuOptions; track phase) {
      <li (click)="selectedExpertsCount ? handlePhaseMenuSelect(clickDirection, phase.key) : closePhaseMenuOverlay()">
        {{ phase.value }}
      </li>
    }
  </section>
</ng-template>
